<div *ngIf="loaderShow">
  <app-loader></app-loader>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="chat-intro-area">
      <div class="chat-intro-icon">

      </div>
      <div class="chat-intro-text" id ="chat-intro-text">
        <div class="row m-b-15">
          <div class="col-12 text-center">
            <p class="m-t-20 m-b-0">
              <span [innerHtml]="configdata.IntroDetails"></span>
            </p>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="custom-tabs">
              <input type="radio" id="link1" name="sidetabs" (click)="handleClick('link1')" [checked]="configdata.isPopularQuestionStart">
              <label class="c-tab" for="link1" id ='about-button'>
                About {{ configdata.chatbotName }}
              </label>
              <input type="radio" id="link2" name="sidetabs" (click)="handleClick('link2')" [checked]="!configdata.isPopularQuestionStart">
              <label class="c-tab" for="link2" id ='start-with-popular-topics-button'> 
                Start with popular topics
              </label>
              <span class="mover" [class.right]="!configdata.isPopularQuestionStart"></span>
            </div>
          </div>
        </div>

        <div class="row m-b-15"
          *ngIf="(configdata.isPopularQuestionStart)">
          <div class="col-12">
            <div class="chatbot-intro-section">
              <div class="section">
                <span class="icon">
                  <img src="./assets/images/intro.svg" alt="Intro" title="Intro" />
                  <h4>Intro</h4>
                </span>
                <span [innerHtml]="configdata.ReggieIntro"></span>
              </div>
              <div class="section">
                <span class="icon">
                  <img src="./assets/images/Disclaimer.svg" alt="Disclaimer" title="Disclaimer" />
                  <h4>Disclaimer</h4>
                </span>
                <span [innerHtml]="configdata.ReggieDisclaimer"></span>
              </div>
              <div class="section">
                <span class="icon">
                  <img src="./assets/images/tips.svg" alt="Tips" title="tips" />
                  <h4>Tips</h4>
                </span>
                <span [innerHtml]="configdata.ReggieTips"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="row m-b-15"
          *ngIf="(!configdata.isPopularQuestionStart) && popularQuestions != null && popularQuestions.length>0">
          <div class="col-12" *ngIf="isStaticQavailable">
            <p class="m-t-0 m-b-0 font-subheading1 line-height-20">
              <span [innerHtml]="configdata.PopularQuestionContent"></span>
              <span class="questions-start m-t-15">
                <ng-container *ngFor="let pq of popularQuestions; let i = index">
                  <div *ngIf="pq.type=='S'">
                    <a href="javascript: void(0)" (click)="PopularQuestionClick(pq.question)"
                    [id]="'popularquestion' + i"class="text-primary font-subheading1">{{pq.question}}</a>
                  </div>
                </ng-container>
              </span>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>